import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { Navigate, RouteObject } from 'react-router';

// Layouts
import AuthorizedLayout from './layouts/AuthorizedLayout';
import UnauthorizedLayout from './layouts/UnauthorizedLayout';

// Shared Pages
import PolicyDetails from '@acorn-portal/shared/src/pages/policy/policy-details';
import PortalHome from '@acorn-portal/shared/src/pages/misc/portal-home';
import Registration from '@acorn-portal/shared/src/pages/registration/Registration';
import ChangePassword from '@acorn-portal/shared/src/pages/misc/ChangePassword';
import ErrorPage from '@acorn-portal/shared/src/pages/misc/ErrorPage';
import PaymentAgreement from '@acorn-portal/shared/src/pages/payNow/payment-agreement';
import ProcessPayment from '@acorn-portal/shared/src/pages/payNow/process-payment';
import ChangeOfAddress from '@acorn-portal/shared/src/pages/mta/change-of-address';
import OverDueInstallmentPlan from '@acorn-portal/shared/src/pages/payNow/OverDueInstallmentPlan';
import PaymentOptions from '@acorn-portal/shared/src/pages/renewal/PaymentOptions';
import ChangeOfVehiclePart1 from '@acorn-portal/shared/src/pages/mta/ChangeOfVehiclePart1';
import ChangeOfVehiclePart2 from '@acorn-portal/shared/src/pages/mta/ChangeOfVehiclePart2';
import MtaSummaryScreen from '@acorn-portal/shared/src/pages/mta/MtaSummaryScreen';
import ChangeOfUsageTaxi from '@acorn-portal/shared/src/pages/mta/change-of-usage-taxi';
import DirectPayment from '@acorn-portal/shared/src/pages/payNow/direct-payment';
import DirectPaymentConfirmation from '@acorn-portal/shared/src/pages/payNow/DirectPaymentConfirmation';
import MtaPaymentOptions from '@acorn-portal/shared/src/pages/mta/payment-options';
import MakePayment from '@acorn-portal/shared/src/pages/renewal/MakePayment';
import DebtCollectionDirectPayment from '@acorn-portal/shared/src/pages/payNow/debt-collection-direct-payment';
import CancelledPolicyOutstandingBalance from '@acorn-portal/shared/src/pages/payNow/CancelledPolicyOutstandingBalance';
import DebtCollectionPayment from '@acorn-portal/shared/src/pages/payNow/debt-collection-payment';
import LogOutPage from '@acorn-portal/shared/src/pages/misc/LogOut';
import MTAStartDateCheck from '@acorn-portal/shared/src/components/wrapper/MtaStartDateCheckWrapper';
import RenewalsList from '@acorn-portal/shared/src/pages/renewal/RenewalList';
import CancelledPolicy from '@acorn-portal/shared/src/pages/payNow/CancelledPolicy';
import DisclaimerPage from '@acorn-portal/shared/src/pages/renewal/DisclaimerPage';
import RenewalSummaryScreen from '@acorn-portal/shared/src/pages/renewal/RenewalSummaryScreen';
import ChangeOfAddressRenewal from '@acorn-portal/shared/src/pages/renewal/ChangeOfAddress';
import RenewalChangeOfUsageTaxi from '@acorn-portal/shared/src/pages/renewal/ChangeOfUsageTaxi';
import RenewalChangeOfVehiclePart1 from '@acorn-portal/shared/src/pages/renewal/ChangeOfVehiclePart1';
import RenewalChangeOfVehiclePart2 from '@acorn-portal/shared/src/pages/renewal/ChangeOfVehiclePart2';
import OptionalExtras from '@acorn-portal/shared/src/pages/renewal/optional-extras';
import ExpiredLinkPage from '@acorn-portal/shared/src/pages/payNow/ExpiredLinkPage';
import InvalidLinkPage from '@acorn-portal/shared/src/pages/payNow/InvalidLinkPage';
import RenewalReferralPage from '../src/pages/renewal/Refer';
import ChangeOfMileage from '@acorn-portal/shared/src/pages/mta/change-of-mileage';
import MakeAChangeHome from '@acorn-portal/shared/src/pages/mta/make-a-change-home';
import ResendRegistration from '@acorn-portal/shared/src/pages/registration/ResendRegistration';
import TokenisedPaymentAgreement from '@acorn-portal/shared/src/pages/payNow/tokenised-payment-agreement';
import FullPaymentSchedule from '@acorn-portal/shared/src/pages/paymentManagement/FullPaymentSchedule';
import ChangeOfBankDetails from '@acorn-portal/shared/src/pages/paymentManagement/ChangeOfBankDetails';
import ChangeOfPaymentDate from '@acorn-portal/shared/src/pages/paymentManagement/change-of-payment-date';
import CancelledWithDebtPaymentConfirmation from '@acorn-portal/shared/src/pages/payNow/CancelledWithDebtPaymentConfirmation';
import BackOfficePaymentSessionPage from '@acorn-portal/shared/src/pages/payment/back-office-payment-session';
import BackOfficePaymentSessionSuccessPage from '@acorn-portal/shared/src/pages/payment/BackOfficePaymentSessionSuccessPage';
import SplitPaymentAgreement from '@acorn-portal/shared/src/pages/payNow/SplitPaymentAgreement';
import ChangeBankError from '@acorn-portal/shared/src/pages/paymentManagement/pages/change-bank-error';
import ManagedPaymentsError from '@acorn-portal/shared/src/components/copy/ManagedPaymentsError';
import MTAManageDrivers from '@acorn-portal/shared/src/pages/mta/mta-manage-drivers';
import RenewalManageDrivers from '@acorn-portal/shared/src/pages/renewal/renewal-manage-drivers';
import { BraintreeProvider } from '@acorn-portal/shared/src/context/braintree-context';
import StripePaymentFormWrapper from '@acorn-portal/shared/src/components/wrapper/stripe-checkout-wrapper';

// Specific pages
import RenewalChangeUsageOrMileage from './pages/renewal/change-usage-or-mileage';
import MTAChangeUsageOrMileage from './pages/mta/change-usage-or-mileage';
import ChangePaymentDaySuccess from './pages/managePayments/ChangePaymentDaySuccess';
import PaymentConfirmation from './pages/payNow/PaymentConfirmation';
import ChangeBankSuccess from './pages/managePayments/ChangeBankSuccess';
import NeedHelp from './pages/misc/NeedHelp';
import ServiceUnavailable from './pages/misc/ServiceUnavailable';
import ChangeSuccess from './pages/mta/ChangeSuccess';
import MtaReferralPage from './pages/mta/MtaReferral';
import PaymentSuccess from './pages/renewal/PaymentSuccess';
import Refer from './pages/renewal/Refer';

const Routes = () => {
	const routes: RouteObject[] = [
		{
			path: '/portal/',
			element: <AuthorizedLayout />,
			children: [
				{
					element: <PortalHome />,
				},
				{
					path: ROUTE_PATHS.logOut,
					element: <LogOutPage />,
				},
				{
					path: ROUTE_PATHS.home,
					element: <PortalHome />,
				},
				{
					path: `${ROUTE_PATHS.policyDetails}/:policyToken`,
					element: <PolicyDetails />,
				},
				{
					path: ROUTE_PATHS.help,
					element: <NeedHelp />,
				},
				{
					path: ROUTE_PATHS.changePassword,
					element: <ChangePassword />,
				},
				{
					path: ROUTE_PATHS.makeAChangeHome,
					element: <MakeAChangeHome />,
				},
				{
					path: ROUTE_PATHS.makeAChangeAddress,
					element: (
						<MTAStartDateCheck>
							<ChangeOfAddress />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeUsageAndMileage,
					element: (
						<MTAStartDateCheck>
							<MTAChangeUsageOrMileage />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeUsageTaxi,
					element: (
						<MTAStartDateCheck>
							<ChangeOfUsageTaxi />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeVehicle,
					element: (
						<MTAStartDateCheck>
							<ChangeOfVehiclePart1 />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeMileage,
					element: (
						<MTAStartDateCheck>
							<ChangeOfMileage />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeVehicle2,
					element: (
						<MTAStartDateCheck>
							<ChangeOfVehiclePart2 />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeDrivers,
					element: (
						<MTAStartDateCheck>
							<MTAManageDrivers />
						</MTAStartDateCheck>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangeSummary,
					element: <MtaSummaryScreen />,
				},
				{
					path: ROUTE_PATHS.makeAChangeReferral,
					element: <MtaReferralPage />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeReferral,
					element: <RenewalReferralPage />,
				},
				{
					path: ROUTE_PATHS.makeAChangePaymentOptions,
					element: (
						<BraintreeProvider>
							<MtaPaymentOptions />
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.makeAChangePaymentSuccess,
					element: <ChangeSuccess />,
				},
				{
					path: ROUTE_PATHS.renewalCheckout,
					element: (
						<BraintreeProvider>
							<StripePaymentFormWrapper>
								<MakePayment />
							</StripePaymentFormWrapper>
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.policyRenewals,
					element: <RenewalsList />,
				},

				{
					path: ROUTE_PATHS.renewalMakeAChangeVehicle,
					element: <RenewalChangeOfVehiclePart1 />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeUsageTaxi,
					element: <RenewalChangeOfUsageTaxi />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeVehicle2,
					element: <RenewalChangeOfVehiclePart2 />,
				},
				{
					path: ROUTE_PATHS.renewalCheckoutSuccess,
					element: <PaymentSuccess />,
				},
				{
					path: `${ROUTE_PATHS.renewalDisclaimer}/:policyToken`,
					element: <DisclaimerPage />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeSummary,
					element: <RenewalSummaryScreen />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeUsageAndMileage,
					element: <RenewalChangeUsageOrMileage />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeAddress,
					element: <ChangeOfAddressRenewal />,
				},
				{
					path: ROUTE_PATHS.renewalOptionalExtras,
					element: <OptionalExtras />,
				},
				{
					path: ROUTE_PATHS.renewalMakeAChangeDrivers,
					element: <RenewalManageDrivers />, //ManageDrivers serviceType="Renewal" />,
				},
				{
					path: `${ROUTE_PATHS.policyRenewals}/make-payment`,
					element: <MakePayment />,
				},
				{
					path: ROUTE_PATHS.policyRenewalRefer,
					element: <Refer />,
				},
				{
					path: `${ROUTE_PATHS.policyRenewals}/payment`,
					element: <PaymentOptions />,
				},
				{
					path: ROUTE_PATHS.error,
					element: <ErrorPage />,
				},
			],
		},
		{
			path: '/pay-now/',
			element: <AuthorizedLayout />,
			children: [
				{
					index: true,
					path: `${ROUTE_PATHS.paymentPlan}/:policyToken?`,
					element: <PaymentAgreement />,
				},
				{
					index: true,
					path: `${ROUTE_PATHS.splitPaymentPlan}/:policyToken?`,
					element: <SplitPaymentAgreement />,
				},
				{
					path: `${ROUTE_PATHS.paymentPlanOverdue}/:policyToken?`,
					element: <OverDueInstallmentPlan />,
				},
				{
					path: `${ROUTE_PATHS.processPayment}/:policyToken?`,
					element: (
						<BraintreeProvider>
							<ProcessPayment />
						</BraintreeProvider>
					),
				},
				{
					path: `${ROUTE_PATHS.payNowSPDirectPayment}/:policyToken?`,
					element: (
						<BraintreeProvider>
							<DirectPayment />
						</BraintreeProvider>
					),
				},
				{
					path: `${ROUTE_PATHS.payNowConfirmation}/:policyToken?`,
					element: <PaymentConfirmation />,
				},
				{
					path: `${ROUTE_PATHS.canxOutstandingBalance}/:policyToken?`,
					element: <CancelledPolicyOutstandingBalance />,
				},
				{
					path: `${ROUTE_PATHS.canxPayment}/:policyToken?`,
					element: <DebtCollectionPayment />,
				},
				{
					path: `${ROUTE_PATHS.canxPaymentSuccess}/:policyToken?`,
					element: <CancelledWithDebtPaymentConfirmation />,
				},
				{
					path: `${ROUTE_PATHS.canxCancelledPolicy}/:policyToken?`,
					element: <CancelledPolicy />,
				},
			],
		},
		{
			path: '/payment-management/',
			element: <AuthorizedLayout />,
			children: [
				{
					path: ROUTE_PATHS.fullPaymentSchedule,
					element: <FullPaymentSchedule />,
				},
				{
					path: ROUTE_PATHS.paymentManagementChangeBankDetails,
					element: <ChangeOfBankDetails />,
				},
				{
					path: ROUTE_PATHS.paymentManagementChangePaymentDate,
					element: <ChangeOfPaymentDate />,
				},
				{
					path: ROUTE_PATHS.paymentManagementChangePaymentDateSuccess,
					element: <ChangePaymentDaySuccess />,
				},

				{
					path: ROUTE_PATHS.changeBankSuccess,
					element: <ChangeBankSuccess />,
				},
				{
					path: ROUTE_PATHS.changeBankError,
					element: (
						<ChangeBankError>
							<ManagedPaymentsError company='STREETCOVER' errorType='changeBankError' />
						</ChangeBankError>
					),
				},
			],
		},
		{
			path: '/account/',
			element: <UnauthorizedLayout />,
			children: [
				{
					path: ROUTE_PATHS.register,
					element: <Registration />,
				},
				{
					path: ROUTE_PATHS.resendRegistration,
					element: <ResendRegistration />,
				},
			],
		},
		{
			path: '/payment/',
			element: <UnauthorizedLayout />,
			children: [
				{
					path: ROUTE_PATHS.payNowDirectPayment,
					element: (
						<BraintreeProvider>
							<DirectPayment />
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.payNowDirectDebitPayment,
					element: (
						<BraintreeProvider>
							<DirectPayment />
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.payNowDirectPaymentSuccess,
					element: <DirectPaymentConfirmation />,
				},
				{
					path: ROUTE_PATHS.canxDirectPayment,
					element: <DebtCollectionDirectPayment />,
				},
				{
					path: ROUTE_PATHS.canxDirectPaymentSuccess,
					element: <DirectPaymentConfirmation />,
				},
				{
					path: ROUTE_PATHS.expiredPaymentLink,
					element: <ExpiredLinkPage />,
				},
				{
					path: ROUTE_PATHS.invalidPaymentLink,
					element: <InvalidLinkPage />,
				},
				{
					path: ROUTE_PATHS.payNowDirectAgreement,
					element: <TokenisedPaymentAgreement />,
				},
				{
					path: ROUTE_PATHS.backOfficePaymentSession,
					element: (
						<BraintreeProvider>
							<BackOfficePaymentSessionPage />
						</BraintreeProvider>
					),
				},
				{
					path: ROUTE_PATHS.backOfficePaymentSessionSuccess,
					element: <BackOfficePaymentSessionSuccessPage />,
				},
			],
		},
		{
			path: '/outage/',
			element: <UnauthorizedLayout />,
			children: [
				{
					index: true,
					element: <ServiceUnavailable />,
				},
			],
		},
		{
			path: '/err/',
			element: <UnauthorizedLayout />,
			children: [
				{
					path: ROUTE_PATHS.unauthorisedError,
					element: <ErrorPage />,
				},
			],
		},
		{
			path: '*',
			element: <Navigate to='/portal/home' replace />,
		},
	];
	return routes;
};

export default Routes;
